import { render, staticRenderFns } from "./lecture.vue?vue&type=template&id=22c062a8&scoped=true&"
import script from "./lecture.vue?vue&type=script&lang=js&"
export * from "./lecture.vue?vue&type=script&lang=js&"
import style0 from "./lecture.vue?vue&type=style&index=0&id=22c062a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c062a8",
  null
  
)

export default component.exports